import { drawingSubmissionError } from '../../utils/drawingSubmission';
import { Button, Link, FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography, Select, Option, Autocomplete, Textarea, IconButton, Card, CardContent, Chip, Box, Stepper, Step, StepIndicator, CircularProgress, Divider, Tooltip, Sheet, Switch, Alert } from "@mui/joy";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { LayoutContext } from "../../context";
import { motion, AnimatePresence } from "framer-motion";

import ModalAddEventService from "./ModalAddEventService";
import { Rating } from "@mui/material";
import { APICreateEmployeeReview } from "../../api";
import StarRating from "../StarRating";




export default function ModalReviewEmployee() {
    const { modalReviewEmployee, setModalReviewEmployee, account, updateListEvents, getDeals } = useContext(LayoutContext);
    const [loading, setLoading] = useState(false);
    const submitFlight = useRef(false);
    const errorRef = useRef(null);
    const [error, setError] = useState("");
    const [hoveredStar, setHoveredStar] = useState({ quality_TZ: 0, quality: 0, response: 0 });
    
    // Состояния для формы отзыва
    const [starsQualityTZ, setStarsQualityTZ] = useState(0);
    const [starsQuality, setStarsQuality] = useState(0);
    const [starsResponse, setStarsResponse] = useState(0);
    const [comment, setComment] = useState("");

    const isAutoOpen = modalReviewEmployee.event && modalReviewEmployee.event.id;

    useEffect(() => {
        if (error) errorRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
    }, [error]);

    const handleSubmit = async () => {
        if (submitFlight.current) return;
        // Валидация
        if (starsQualityTZ === 0 || starsQuality === 0 || starsResponse === 0) {
            setError("Пожалуйста, оцените все три критерия");
            return;
        }
        
        // НОВАЯ ПРОВЕРКА: если средний рейтинг <= 4, комментарий обязателен
        const ratedCategories = [starsQualityTZ, starsQuality, starsResponse].filter(val => val > 0);
        const averageRating = ratedCategories.length > 0 
            ? ratedCategories.reduce((sum, val) => sum + val, 0) / ratedCategories.length 
            : 0;

        if (averageRating <= 4 && !comment.trim()) {
            setError("При оценке 4 и ниже комментарий обязателен для улучшения качества работы");
            return;
        }

        if (comment.trim() && comment.trim().length < 10) {
            setError("Комментарий должен содержать минимум 10 символов");
            return;
        }

        submitFlight.current = true;
        setLoading(true);
        setError("");

        try {
            const reviewData = {
                employee_leaving: account.id,
                about_employee: modalReviewEmployee.about_employee,
                event: modalReviewEmployee.event?.id,
                type_review: 'draftsman_to_surveyor',
                stars_quality_TZ: starsQualityTZ || 0,
                stars_quality: starsQuality || 0,
                stars_response: starsResponse || 0,
                comment: comment.trim()
            };

            const submitted = modalReviewEmployee.onSubmit
                ? await modalReviewEmployee.onSubmit(reviewData)
                : await APICreateEmployeeReview(reviewData);
            const response = submitted === true ? { status: 'ok' } : submitted;
            
            if (response?.status === "ok") {
                if (!modalReviewEmployee.onSubmit) alert('Отзыв успешно отправлен!');
                resetForm();
                setModalReviewEmployee(prev => ({
                    ...prev,
                    open: false
                }));
                // Обновляем список событий чертёжника, чтобы у завершённой карточки
                // пропала кнопка «Оставить отзыв» (флаг can_leave_surveyor_review перейдёт в false)
                try {
                    if (account?.id && account?.position?.includes?.('draftsman')) {
                        updateListEvents?.('drawing', account.id);
                    }
                    getDeals?.();
                } catch (e) {
                    console.warn('Не удалось обновить список после отзыва:', e);
                }
            } else {
                setError(drawingSubmissionError(response));
            }
        } catch (error) {
            setError(drawingSubmissionError(error));
            console.error("Error submitting review:", error);
        } finally {
            submitFlight.current = false;
            setLoading(false);
        }
    };

    const resetForm = () => {
        setStarsQualityTZ(0);
        setStarsQuality(0);
        setStarsResponse(0);
        setComment("");
        setError("");
        setHoveredStar({ quality_TZ: 0, quality: 0, response: 0 });
    };

    const handleClose = () => {
        if (loading) return;
        resetForm();
        setModalReviewEmployee(prev => ({
            ...prev,
            open: false
        }));
    };

    const getEmployeeName = () => {
        return modalReviewEmployee.about_employee_name || "Исполнитель";
    };

    const getRatingDescription = (category, value) => {
        const descriptions = {
            quality_TZ: {
                1: "Очень плохое качество ТЗ",
                2: "Плохое качество ТЗ",
                3: "Среднее качество ТЗ", 
                4: "Хорошее качество ТЗ",
                5: "Отличное качество ТЗ"
            },
            quality: {
                1: "Очень плохое качество",
                2: "Плохое качество",
                3: "Среднее качество",
                4: "Хорошее качество", 
                5: "Отличное качество"
            },
            response: {
                1: "Очень плохая коммуникация",
                2: "Плохая коммуникация", 
                3: "Средняя коммуникация",
                4: "Хорошая коммуникация",
                5: "Отличная коммуникация"
            }
        };
        
        return descriptions[category]?.[value] || "";
    };

    const ratedCategories = [starsQualityTZ, starsQuality, starsResponse].filter(val => val > 0);
    const averageRating = ratedCategories.length > 0 
        ? ratedCategories.reduce((sum, val) => sum + val, 0) / ratedCategories.length 
        : 0;
    const displayRating = Math.round(averageRating * 100) / 100;

    return (
        <AnimatePresence>
            {modalReviewEmployee.open && (
                <Modal
                    sx={{ zIndex: 10102, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    open={modalReviewEmployee.open}
                    onClose={handleClose}
                    slotProps={{
                        backdrop: {
                            component: motion.div,
                            initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                            animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                            exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                            transition: { duration: 0.3, ease: "easeInOut" },
                        }
                    }}
                >
                    <ModalOverflow sx={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1.5 }}>
                        <ModalDialog
                            size="md"
                            component={motion.div}
                            initial={{ opacity: 0, y: -10, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 10, scale: 0.98 }}
                            transition={{ duration: 0.2, ease: "easeInOut" }}
                            sx={(theme) => ({
                                [theme.breakpoints.down("sm")]: {
                                    width: '95%',
                                    p: 3,
                                },
                                position: 'relative', top: 'auto', left: 'auto', transform: 'none', maxHeight: 'calc(100dvh - 24px)', overflowY: 'auto',
                                width: '500px'
                            })}
                        >
                            {/* <ModalClose onClick={handleClose}/> */}
                            <Typography sx={{ textAlign: 'center', mb: 2 }} level="h3">
                                {isAutoOpen ? "Оцените работу обмерщика" : "Отзыв о работе обмерщика"}
                            </Typography>

                            {isAutoOpen && (
                                <Alert color="success" sx={{ mb: 2 }}>
                                    <Typography level="body-sm">
                                        {modalReviewEmployee.requiredForCompletion ? 'Оцените все три критерия. После сохранения оценки чертёж будет отправлен на контроль качества. Если закрыть окно, работа останется незавершённой.' : 'Оцените работу обмерщика по всем трём критериям.'}
                                    </Typography>
                                </Alert>
                            )}
                            
                            <Sheet color="primary" variant="soft" sx={{ borderRadius: "lg", p: 1 }}>
                                <Typography level="h4" sx={{ textAlign: 'center', color: 'primary.500' }}>
                                    Исполнитель: {getEmployeeName()}
                                </Typography>
                            </Sheet>

                            <Typography level="body-md" sx={{ mt: 2, textAlign: 'center' }}>
                                Оцените работу по следующим критериям:
                            </Typography>
                            
                            <Stack spacing={3}>
                                {/* Скорость работы */}
                                <FormControl>
                                    <FormLabel>
                                        <Typography level="title-lg">📋 Качество ТЗ</Typography>
                                        <Typography level="body-sm">
                                            Насколько качественно и полно передано и выполнено техническое задание?
                                        </Typography>
                                    </FormLabel>
                                    <Box sx={{ mt: 2 }}>
                                        <StarRating
                                            label="Качество ТЗ" value={starsQualityTZ}
                                            onChange={setStarsQualityTZ}
                                            size="large"
                                        />
                                        {starsQualityTZ > 0 && (
                                            <Typography 
                                                level="body-sm" 
                                                color="primary" 
                                                sx={{ mt: 1, fontStyle: 'italic' }}
                                            >
                                                {getRatingDescription('quality_TZ', starsQualityTZ)}
                                            </Typography>
                                        )}
                                    </Box>
                                </FormControl>

                                {/* Качество работы */}
                                <FormControl>
                                    <FormLabel>
                                        <Typography level="title-lg">🎯 Качество работы</Typography>
                                        <Typography level="body-sm">
                                            Насколько качественно выполнены замеры? Полнота материалов, четкость фото/видео.
                                        </Typography>
                                    </FormLabel>
                                    <Box sx={{ mt: 2 }}>
                                        <StarRating
                                            label="Качество работы" value={starsQuality}
                                            onChange={setStarsQuality}
                                            size="large"
                                        />
                                        {starsQuality > 0 && (
                                            <Typography 
                                                level="body-sm" 
                                                color="primary"
                                                sx={{ mt: 1, fontStyle: 'italic' }}
                                            >
                                                {getRatingDescription('quality', starsQuality)}
                                            </Typography>
                                        )}
                                    </Box>
                                </FormControl>

                                {/* Отклик и коммуникация */}
                                <FormControl>
                                    <FormLabel>
                                        <Typography level="title-lg">💬 Отклик и коммуникация</Typography>
                                        <Typography level="body-sm">
                                            Насколько оперативно и четко обмерщик отвечал на вопросы по замерам?
                                        </Typography>
                                    </FormLabel>
                                    <Box sx={{ mt: 2 }}>
                                        <StarRating
                                            label="Отклик" value={starsResponse}
                                            onChange={setStarsResponse}
                                            size="large"
                                        />
                                        {starsResponse > 0 && (
                                            <Typography 
                                                level="body-sm" 
                                                color="primary"
                                                sx={{ mt: 1, fontStyle: 'italic' }}
                                            >
                                                {getRatingDescription('response', starsResponse)}
                                            </Typography>
                                        )}
                                    </Box>
                                </FormControl>

                                {/* Комментарий */}
                                <FormControl>
                                    <FormLabel>
                                        <Typography level="title-lg">📝 Комментарий</Typography>
                                        <Typography level="body-sm">
                                            Опишите подробнее ваши впечатления от работы. Что понравилось, что можно улучшить?
                                            {averageRating <= 4 && (
                                                <Typography component="span" color="danger" fontWeight="bold">
                                                    {" "}*обязательно при оценке 4 и ниже
                                                </Typography>
                                            )}
                                        </Typography>
                                    </FormLabel>
                                    <Textarea 
                                        value={comment} 
                                        onChange={(e) => setComment(e.target.value)} 
                                        size="md"
                                        minRows={4}
                                        placeholder="Например: Материалы были переданы быстро, но некоторые фото были недостаточно четкими. В целом работа выполнена качественно."
                                        sx={{ mt: 1 }}
                                    />
                                    <Typography level="body-xs" color="neutral" sx={{ mt: 0.5 }}>
                                        {averageRating <= 4 || comment.trim() ? `Минимум 10 символов. Осталось: ${Math.max(0, 10 - comment.trim().length)}` : 'При оценке выше 4 комментарий необязателен.'}
                                    </Typography>
                                </FormControl>

                                {/* Общий рейтинг */}
                                {(starsQualityTZ > 0 || starsQuality > 0 || starsResponse > 0) && (
                                    <Box sx={{ 
                                        p: 2, 
                                        backgroundColor: 'primary.50', 
                                        borderRadius: 'md',
                                        border: '1px solid',
                                        borderColor: 'primary.200'
                                    }}>
                                        <Typography level="title-md" sx={{ textAlign: 'center', mb: 1 }}>
                                            Общий рейтинг
                                        </Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                                            <StarRating
                                                value={Math.round(averageRating)}
                                                readOnly
                                                size="medium"
                                            />
                                            <Typography level="title-lg" color="primary">
                                                {displayRating.toFixed(2)}/5
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}

                                {error && (
                                    <Alert ref={errorRef} role="alert" color="danger" sx={{ mb: 2 }}>
                                        {error}
                                    </Alert>
                                )}

                                <Button 
                                    onClick={handleSubmit} 
                                    loading={loading} 
                                    size="lg" 
                                    variant="solid" 
                                    color="primary"
                                    disabled={(starsQualityTZ === 0 || starsQuality === 0 || starsResponse === 0) || 
                                                (averageRating <= 4 && comment.trim().length < 10) ||
                                                (!!comment.trim() && comment.trim().length < 10)}
                                    sx={{ mt: 2 }}
                                >
                                    {modalReviewEmployee.requiredForCompletion ? 'Сохранить оценку и завершить' : 'Отправить отзыв'}
                                </Button>

                                <Button variant="plain" color="neutral" disabled={loading} onClick={handleClose}>Вернуться к работе</Button>
                                {/* {isAutoOpen && (
                                    <Button 
                                        onClick={handleClose} 
                                        size="md" 
                                        variant="outlined" 
                                        color="neutral"
                                    >
                                        Пропустить отзыв
                                    </Button>
                                )} */}
                            </Stack>
                        </ModalDialog>
                    </ModalOverflow>
                </Modal>
            )}
        </AnimatePresence>
    );
}